import * as React from "react";
import {EgenciaProvider, UitkCard} from "@egencia/uitk-react";
import {Article} from "./article";


export function ArticleDetailsSingleArticle({article}) {
    React.useEffect(() => {
        convertWistiaTagsToEmbedScripts()
    });
    return (<EgenciaProvider>
        <UitkCard border={true} padding={"medium"}>
            <Article article={article}/>
        </UitkCard>
    </EgenciaProvider>)
}